import { formatPrice } from 'utils/format';
import { couponPairingSale, couponSale } from 'ecommerce/lib/coupon';

// Price strings for landing page tiles and idea cards (docs/product-tiles.md). Starting prices,
// .00 omitted for whole dollars, with the claimed coupon's reduction when it covers the product.

// Omit .00 for whole-dollar prices while preserving fractional coupon savings.
export const money = (amount, currency) => formatPrice(amount, currency)?.replace(/\.00$/, '');

// One product: the props LandingProductTile and PriceTag take.
export const productPrice = (product, previewSummary) => {
  if (!product) return {};
  const sale = couponSale(previewSummary, product);
  const discounted = sale?.discountedPriceFrom;
  return {
    amount: discounted ?? product.prices[0],
    price: money(discounted ?? product.prices[0], product.currency),
    originalPrice: discounted != null ? money(product.prices[0], product.currency) : undefined,
    saleBadge: sale?.badge,
    priceFrom: product.prices.length > 1,
  };
};

// A pairing of products priced together from their starting prices. Always "from" when there
// is more than one product. Null while a product is missing from the catalog.
export const ideaPrice = (products, previewSummary) => {
  if (products.some((product) => !product)) return null;
  const { currency } = products[0];
  const total = products.reduce((sum, product) => sum + product.prices[0], 0);
  const sale = couponPairingSale(previewSummary, products);
  const discounted = sale?.discountedPriceFrom;
  return {
    amount: discounted ?? total,
    price: money(discounted ?? total, currency),
    originalPrice: discounted != null ? money(total, currency) : undefined,
    badge: sale?.badge,
    priceFrom: products.length > 1 || products[0].prices.length > 1,
  };
};
